import { Component, OnInit } from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";

@Component({
  selector: "app-index-payments",
  templateUrl: "./index-payments.component.html",
  styleUrls: ["./index-payments.component.css"],
})

/***
 * paymenyt Component
 */
export class IndexPaymentsComponent implements OnInit {

  // Set Topbar Option
  Menuoption = 'center';
  Settingicon = true
  /***
   * Testimonial Slider
   */
  customOptions: OwlOptions = {
    // loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    // autoplay: true,
    navSpeed: 700,
    navText: ["", ""],
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      900: {
        items: 3,
      },
    },
    nav: false,
  };

  constructor() {}

  ngOnInit(): void {}
}
